import { Component, OnInit, Input } from '@angular/core';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-catalogs-preparations-breadcrumb-card',
  templateUrl: './catalogs-preparations-breadcrumb-card.component.html',
  styleUrls: ['./catalogs-preparations-breadcrumb-card.component.scss']
})
export class CatalogsPreparationsBreadcrumbCardComponent implements OnInit {

  @Input() preparations;
  selectedOption;
  filterOpened: boolean;
  viewDisposition;

  constructor(private userStorageService: UserStorageService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private preparationsService: PreparationsService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    if (this.userStorageService.getFilterDevices()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public newPreparation() {
    this.router.navigate(['../preparation'], { relativeTo: this.activatedRoute.parent});
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.preparationsService.togglePreparationsDisposition(viewDis);
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.preparationsService.searchPreparations(event.target.value);
  }
}
